import { Box as RebassBox } from 'rebass/styled-components';
import { border, compose, gridArea, gridColumn, gridRow, position } from 'styled-system';

import styled from 'styled-components';

const Box = styled(RebassBox)(compose(position, border, gridColumn, gridRow, gridArea));

export default Box;
